export default function ($http) {
    return function (importId) {
        return $http({
            method: 'GET',
            url: `/api/importfile/contents/${ importId }`,
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/data-import-export/services/import/getImportRecords.js